import React from 'react';
import CustomTooltip from '../../../common/CustomTooltip/CustomTooltip';
import LinkIcon from '../../../../assets/icons/LinkIcon';
import styles from '../../../../styles/usageRights.module.css';

interface ActionsSectionProps {
  onClick: (e: React.MouseEvent<HTMLDivElement, MouseEvent>) => unknown;
}

function ActionsSection({ onClick }: ActionsSectionProps) {
  return (
    <div role="presentation" className={styles.actionsContainer} onClick={onClick}>
      <CustomTooltip title="Review Request">
        <LinkIcon width={24} height={24} style={{ cursor: 'pointer' }} />
      </CustomTooltip>
    </div>
  );
}

export default ActionsSection;
